<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 6C12 5.44772 12.4477 5 13 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H13C12.4477 7 12 6.55228 12 6Z"
      fill="currentColor"
    />
    <path
      d="M12 10C12 9.44772 12.4477 9 13 9H19C19.5523 9 20 9.44772 20 10C20 10.5523 19.5523 11 19 11H13C12.4477 11 12 10.5523 12 10Z"
      fill="currentColor"
    />
    <path
      d="M12 14C12 13.4477 12.4477 13 13 13H17C17.5523 13 18 13.4477 18 14C18 14.5523 17.5523 15 17 15H13C12.4477 15 12 14.5523 12 14Z"
      fill="currentColor"
    />
    <path
      d="M0 5C0 4.44772 0.447715 4 1 4H9C9.55228 4 10 4.44772 10 5V15C10 15.5523 9.55228 16 9 16H1C0.447716 16 0 15.5523 0 15V5Z"
      fill="currentColor"
    />
  </svg>
</template>
